const Marionette = require('backbone.marionette');
const templates = require('../templates');
const app = require('../app.js');

const ActivityChildView = Marionette.ItemView.extend({
  className: 'course',
  template: templates.footer_activity,
  serializeModel() {
    return { course: this.model };
  },
  onBeforeShow() {
    if (this.model.get('isNext')) {
      app.vent.trigger('displayFooterNext');
    } else {
      app.vent.trigger('displayFooterActually');
    }
  },
  modelEvents: {
    change: 'render'
  }
});

module.exports = Marionette.CompositeView.extend({
  template: templates.footer_activities,
  childView: ActivityChildView,
  childViewContainer: '.courses',
  emptyView: Marionette.ItemView.extend({
    template: templates.footer_activities_empty
  })
});



// WEBPACK FOOTER //
// ./src/views/footer_activities.js